import { equals } from '@execonline-inc/collections';
import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import InviteTimeForm from '../../../../../SharedComponents/InviteTimeForm';
import SkipInvitation from '../../../../../SharedComponents/SkipInvitation';
import InviteParticipantStore from '../../../Store';
import { Inviting, Submitting } from '../../../Types';
import Form from './Form';
import SkipCommunications from './SkipCommunications';
import Submit from './Submit';

export interface Props {
  store: InviteParticipantStore;
  state: Inviting | Submitting;
}

function Body({ store, state }: Props) {
  return (
    <>
      <SkipCommunications
        skipCommunications={state.skipCommunications}
        setSkipCommunications={store.setSkipCommunications}
      />
      {when(equals(true), state.skipCommunications)
        .map(() => <SkipInvitation />)
        .getOrElseValue(
          <InviteTimeForm>
            <Form store={store} state={state} />
          </InviteTimeForm>,
        )}
      <Submit store={store} />
    </>
  );
}

export default observer(Body);
